import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  IconButton,
  FormControlLabel,
  Checkbox,
  Typography,
  Box
} from '@mui/material';
import {
  Delete as DeleteIcon,
  Schedule as ScheduleIcon
} from '@mui/icons-material';
import TimeSelector from './TimeSelector';

const TimeSlotCard = ({ 
  slot, 
  onUpdate, 
  onDelete, 
  dayName, 
  slotIndex,
  disabled = false 
}) => {
  const handleFieldChange = (field, value) => {
    onUpdate(slotIndex, field, value);
  };

  const handleDelete = () => {
    onDelete(slotIndex);
  };

  return (
    <Card 
      sx={{ 
        mb: 2, 
        p: 1, 
        border: '1px solid #e0e0e0',
        backgroundColor: slot.isActive ? '#fafafa' : '#f5f5f5',
        opacity: slot.isActive ? 1 : 0.7
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Grid container spacing={2} alignItems="center">
          {/* Slot Icon */}
          <Grid item xs={12} sm={1}>
            <Box display="flex" justifyContent="center">
              <ScheduleIcon color="primary" />
            </Box>
          </Grid>

          {/* Start Time */}
          <Grid item xs={12} sm={3}>
            <TimeSelector
              label="Start Time"
              value={slot.startTime}
              onChange={(value) => handleFieldChange('startTime', value)}
              disabled={disabled || !slot.isActive}
              fullWidth={true}
            />
          </Grid>

          {/* End Time */}
          <Grid item xs={12} sm={3}>
            <TimeSelector
              label="End Time"
              value={slot.endTime}
              onChange={(value) => handleFieldChange('endTime', value)}
              disabled={disabled || !slot.isActive}
              fullWidth={true}
            />
          </Grid>

          {/* Hours */}
          <Grid item xs={12} sm={2}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Hours
            </Typography>
            <Typography variant="h6" color="primary">
              {slot.totalHours}
            </Typography>
          </Grid>

          {/* Active Toggle */}
          <Grid item xs={12} sm={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={slot.isActive}
                  onChange={(e) => handleFieldChange('isActive', e.target.checked)}
                  disabled={disabled}
                  color="primary"
                />
              }
              label="Active"
              labelPlacement="top"
            />
          </Grid>

          {/* Delete Button */}
          <Grid item xs={12} sm={1}>
            <Box display="flex" justifyContent="center">
              <IconButton
                onClick={handleDelete}
                color="error"
                size="small"
                disabled={disabled}
                title="Delete Time Slot"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Slot Info */}
        <Box mt={1}>
          <Typography variant="caption" color="text.secondary">
            Slot {slotIndex + 1} • {dayName} • {slot.startTime} - {slot.endTime} ({slot.totalHours} hours)
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TimeSlotCard;
